/* Instantiating Chart.js */
var Chart = require('./chart.bundle.min.js');
/* Script the runs Skye Custom Chart Generations */
function WorkSCharts() {
	'use strict';
	var winWidth = function () {
		var winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		return winW;
	};
	/* Will add looping Object  to generate the tube charts  */

	function SkyeChartGenerator(theId, theType, theData, aspectRatio, responsive, labels, labelsArray) {
		this.ctx = document.getElementById(theId).getContext('2d');
		this.type = theType;
		this.theData = theData;
		this.aspectRatio = aspectRatio;
		this.responsive = responsive;
		this.winWidth = winWidth();
		this.labelMsg = labels;
		this.labelsArray = '';
		this.labelsArrayChk = function () {
			if (this.winWidth < 1280) {
				this.labelsArray = labelsArray;
			} else {
				this.labelsArray = false;
			}
			return this.labelsArray;
		};

		this.generate = function () {
			this.labelsArrayChk();
			var myChart = new Chart(this.ctx, {
				type: this.type,
				data: {
					labels: this.labelsArray,
					datasets: [
						this.theData
					]
				},
				options: {
					maintainAspectRatio: this.aspectRatio,
					responsive: this.responsive,
					tooltips: {
						enabled: false
					}
				}
			});
		};
		this.generate();
	}
	var theColorSet = ['#FA9430', '#DFDFDF'];
	/*Generate First Doughnut Chart */
	var theDataSet1 = {
		data: [46, 54],
		labels: '',
		backgroundColor: ['#FA9430', '#DFDFDF'],
		borderWidth: 0
	};
	/* Instantiate object for the doughnut chart creation */
	var tubeChart1 = new SkyeChartGenerator('surveyTubeChart1', 'doughnut', theDataSet1, false, true, false);
	/* END DOUGHNUT CHART CREATION 1*/

	/*Generate Second Doughnut Chart */
	var theDataSet2 = {
		data: [49, 51],
		labels: '',
		backgroundColor: theDataSet1.backgroundColor,
		borderWidth: theDataSet1.borderWidth
	};
	/* Instantiate object for the doughnut chart creation */
	var tubeChart2 = new SkyeChartGenerator('surveyTubeChart2', 'doughnut', theDataSet2, false, true, false);
	/* END DOUGHNUT CHART CREATION 2*/

	/*Generate Third Doughnut Chart */
	var theDataSet3 = {
		data: [52,48],
		labels: '',
		backgroundColor: theDataSet1.backgroundColor,
		borderWidth: theDataSet1.borderWidth
	};
	/* Instantiate object for the doughnut chart creation */
	var tubeChart3 = new SkyeChartGenerator('surveyTubeChart3', 'doughnut', theDataSet3, false, true, false);
	/* END DOUGHNUT CHART CREATION 3*/

	/*Generate PIE Chart */
	var thePieDataSet = {
		data: [56, 25, 17, 2],
		backgroundColor: ['#005882', '#04709E', '#21B5E4', '#FA9430'],
		borderWidth: 0
	};
	/* Instantiate object for the doughnut chart creation */
	var LabelArray = ['56%', '25%', '17%', '2%'];
	var pieChart3 = new SkyeChartGenerator('skyePieChart', 'pie', thePieDataSet, true, true, true, '');

	/* END PIE CHART CREATION*/
	/* Bar Graph Creation Code */
	/* Array of Ids */
	var idsArray = ['#barStat1', '#barStat2', '#barStat3', '#barStat4', '#barStat5', '#barStat6'];
	/* Array of numbers for percentages */
	var percentageArray = [26, 22, 35, 12, 4, 1];
	/* Custom Bar Chart Creation Object */

	function SkyeBarChartGenerate(theIds, thePercentages, theColor) {
		this.ids = theIds;
		this.percentage = thePercentages;
		this.color = theColor;
		this.generateBars = function () {
			for (var ov = 0; ov < this.ids.length; ov++) {
				var theParent = document.querySelector(this.ids[ov]);
				var theBar = theParent.querySelector('.progress-bar');
				theBar.style.width = (this.percentage[ov] * 1.75) + '%';
				theBar.style.maxWidth = (this.percentage[ov] * 1.75) + '%';
				theBar.style.backgroundColor = this.color;
			}
		};
		
	}
	/* Generate Bar Chart */
	var barGen = new SkyeBarChartGenerate(idsArray, percentageArray, '#0198CE');
	barGen.generateBars();
}

window.onload = function(){
	'use strict';
	WorkSCharts();
};